let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Gvpw")).then(() => parcelRequire('9loVs'));